<template lang="pug">
	.item-layout.body-1
		.item-name.caption {{item.name}}
		.item-code.caption {{item.alias_name}}
		.item-price {{salePrice | mixFormatCurrency}}
		.item-quantity {{item.quantity | mixFormatNumber}}
		.item-total {{salePrice * item.quantity | mixFormatCurrency}}
</template>

<script>
import CurrencyUtils from '../../mixins/CurrencyUtils'
export default {
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    filters: {
        short: (val) => {
            return parseInt(val).toFixed(5)
        }
    },
    mixins: [CurrencyUtils],
    computed:{
    salePrice() {
            if (this.item.neto) return this.item.altPrice
            if (this.item.discounted_price) return this.item.discounted_price
            return this.item.sale_price
        },
    }
}
</script>

<style lang="scss" scoped>
.item-layout {
    display: grid;
    grid-template-rows: 24px 24px;
    grid-template-columns: 33% 33% auto;
    padding: 0 10px;
    .item-name {
        grid-column-start: span 2;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 10px;
    }
    .item-code {
        /*text-align: right;*/
    }
    .item-price {
        font-weight: bold;
    }
    .item-total {
        font-weight: bold;
    }
}
</style>
